import theme from 'stories/theme';
import styled from 'styled-components';

export const MultiFactorResendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  margin-top: ${theme.spacing[4]};

  gap: ${theme.spacing[2]};

  button {
    height: auto;
  }
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing[1]};
  text-align: right;
  justify-content: end;
`;
